import { useEffect, useState } from "react";
import { getFeaturedProducts } from "../services/api";
import { Link } from "react-router-dom";

export const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFeaturedProducts()
      .then((data) => {
        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.products)
            ? data.products
            : [];

        setProducts(list);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading featured products...</div>;
  }

  return (
    <section className="px-6 lg:px-12 md:px-12 sm:px-12 xs:px-10 xxs:px-8 py-6 md:py-10 lg:py-10 sm:py-10 xs:py-8 xxs:py-6  mx-auto">
      <h3 className="text-4xl font-serif text-light_primary mb-6">
        Featured Products
      </h3>
      <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {products.map((prod) => (
          <div
            key={prod._id}
            className="bg-light_cream rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300"
          >
            <Link
              to={`/product/${prod._id}`}
              state={{ product: prod }}
              key={prod._id}
            >
              <img
                src={prod.image?.[0] || "https://placebear.com/g/200/200"}
                alt={prod.name}
                className="w-full h-48 object-cover rounded"
              />
              <h4 className="text-center mt-4 font-medium text-lg text-black mb-2">
                {prod.name}
              </h4>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};
